var path = require('../internals/path');

var hasOwn = require('../internals/has-own-property');

var wrappedWellKnownSymbolModule = require('../internals/well-known-symbol-wrapped');

var defineProperty = require('../internals/object-define-property').f;

module.exports = function (NAME) {
  var _Symbol = path.Symbol || (path.Symbol = {});

  if (!hasOwn(_Symbol, NAME)) defineProperty(_Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};